import React from 'react';
import './App.css';
import ProjectList from './project_list';
import { useNavigate } from 'react-router-dom';

function App() {
  const navigate = useNavigate();

  return (
    <div className="App">
      <header className="App-header">
        <p style={{ textAlign: 'left' }}>
          Aiden Zhang <br />
          <span className="red-playfair">Carnegie Mellon University • ECE Class of 2028</span> 
          <br />
        </p>
        <button onClick={() => navigate('/llm')} className="llm-button">
          <span>click me to try llm</span>
          <span className="llm-home-badge">new model alert!</span>
        </button>
      </header>
      <section>
        <p>
          SDE Intern @ IBM Summer 26
          <br />
          <br />
          main page flow:
          <br /> <br />
          cloudfront → api gateway → lambda → dynamodb <br />
          <p>↳s3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        </p>
        <div className="wrapper">
          <div className="content">
            <p>
              - Serveless Design <br />
              - Fast access anywhere<br />
              - API Gateway authentication <br />
              - Scaling based on demand <br />
            </p>
          </div>
        </div>
        <p>
          <br /> Cloudfront serves the built react code from an S3 bucket. The code then calls an API gateway<br />
          to a Lambda function. The Lambda function fetches my list of projects from dynamodb and react<br />
          displays the name, description, and link dynamically. The entire thing runs on AWS for free.
        </p>
      </section>
      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '2rem' }}>
        <p style={{ fontSize: '24px' }}>Projects</p>
        <ProjectList />
      </div>
      <section>
        <p style={{ fontSize: '24px' }}>about me</p>
        Carnegie Mellon University student in ECE Class of 2028, formerly MechE. SDE Intern @ IBM Summer 26<br />
        Interested in ML/robotics<br /> <br /> <br />
      </section>
      <p className="App-foot">copyright</p>
    </div>
  );
}

export default App;
